export const DASHBOARD_ACTION_COLUMN_WIDTH = '76px'
export const DASHBOARD_SEQUENCE_COLUMN_WIDTH = '56px'
export const DASHBOARD_BADGE_FONT_SIZE = 12
export const DASHBOARD_BADGE_MIN_WIDTH = 110
export const DASHBOARD_TABLE_BADGE_STYLE = {
  alignItems: 'center',
  borderRadius: 20,
  display: 'inline-flex',
  fontSize: DASHBOARD_BADGE_FONT_SIZE,
  justifyContent: 'center',
  minWidth: DASHBOARD_BADGE_MIN_WIDTH,
}
